<template>
  <div class="table-responsive" id="contenidox">
    <table class="table table-condensed table-bordered">
      <thead>
        <tr>
          <th>Nro cuota</th>
          <th>ID</th>
          <th>Monto</th>
          <th>Saldo</th>
          <th>Fecha de pago</th>
          <th>Puede pagar</th>
          <th>Cancelado</th>
          <th>Pagos</th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="ind" v-for="(p,ind) in getInscripcion.cuotas_por_pagar">
          <td> {{p.nro_cuota}} </td>
          <td> {{p.id}} </td>
          <td> {{p.monto}} </td>
          <td> {{p.saldo}} </td>
          <td> {{p.fecha}} </td>
          <td> {{p.puede_pagar?'SI':'NO'}} </td>
          <td> {{p.cancelado?'SI':'NO'}} </td>
          <td>
            <div v-bind:key="ind2" v-for="(pp,ind2) in p.pagos">
              <a title="Eliminar este pago." v-show="$store.state.cancelarPagoCuota" @click="preIliminar(p,pp)"> <span class="text-white glyphicon glyphicon-trash">. </span> </a>
              <a title="Generar Recibo." @click="genRecibo(pp)"> <span class="text-white glyphicon glyphicon-print">. </span> </a>
              <small> <b>Submonto:</b> {{pp.monto}} </small>
              <small> <b>Saldo:</b> {{pp.saldo}} </small>
              <small> <b>fecha:</b> {{pp.fecha_pago}} </small>
              <small> <b>Recibo:</b> {{pp.nro_recibo}} </small>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-center"> {{msg}} </p>
  </div>
</template>

<script>
import {parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  props:{ getInscripcion:{type:Object,required:true},listener:{type:Object,required:true} },
  data(){
    return{
      msg: '',
    }
  },
  methods:{
    preIliminar( cuota,pago ){
      var vue = this;
      this.$dialog
      .confirm("<b>Confirmar</b>:<br><br>Eliminar el pago de "+pago.monto+" Bs.<br>Esta accion es irreversible.")
      .then(function() { 
        vue.eliminar( cuota.id,pago.id );
      }).catch(function(e) { 
        window.console.log(e )
      });
    },

    eliminar( idcuota,idpago ){
      this.msg = "Eliminando...";
      var sql = gql`mutation{ cancelarPagoCuota(input:{ idcuota:${idcuota},idpago:${idpago} }){ok,pago_cuota{id},errors{message}} }`;
      // window.console.log( sql, "FLAG ",this.listener.flag );

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        if( data.data.cancelarPagoCuota.ok ){
          this.msg = "Exito."
          this.listener.flag = new Date().getTime();
        }else{
          var errores = JSON.stringify(data.data.cancelarPagoCuota.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          this.msg = vals;
        }
        // window.console.log(data);
      }).catch((error) => {
        this.$notify( parseJsonError( error,'cancelarPagoCuota' ) )
      })
    },

    genRecibo( pago ){
      window.sessionStorage.setItem( 'xrecpago',JSON.stringify(pago) );
      this.$router.push({name:'recibo'});
    }
  }
}
</script>